import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { errorHandl, setFormData, setFormDataV2 } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';
@Injectable({
  providedIn: 'root'
})
export class MoneyForBuckService {

  constructor(private http: HttpClient) { }

  getBucks() {
    // const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.BASE_URL + urls.MONEY_FOR_BUCKS)
      .pipe(
        catchError(errorHandl)
      );
  }
  getBucksbyId(buckId) {
    console.log(buckId);
    // const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.BASE_URL + urls.MONEY_FOR_BUCKS + '/' +`${buckId}` )
      .pipe(
        catchError(errorHandl)
      );
  }
  addBucks(payload, buckId) {
    if (buckId) {
      return this.http.put<any>(urls.BASE_URL + urls.MONEY_FOR_BUCKS + '/' + buckId, payload)
        .pipe(
          catchError(errorHandl)
        );
    } else {
      return this.http.post<any>(urls.BASE_URL + urls.MONEY_FOR_BUCKS, payload)
        .pipe(
          catchError(errorHandl)
        );
    }
  }
  getDashboard(queryParams) {
    return this.http.post<any>(urls.BASE_URL + urls.MONEY_FOR_BUCKS + '/' + urls.MONEY_FOR_BUCKS_DASHBOARD, queryParams)
      .pipe(
        catchError(errorHandl)
      );
  }



}
